var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.id)?_c('spreadsheet',{ref:"sp",attrs:{"opts":_vm.opts},on:{"ready":_vm.onDataReady}}):_c('detail',{attrs:{"opts":_vm.opts,"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }